<div class="flex flex-col dropdown-host" #cardTrigger>

  <!-- Card trigger — #cardTrigger is what the overlay anchors to and measures -->
  <div
    class="card-input flex items-center text-xs py-2 dropdown-card"
    [class.select-active]="isOpen()"
    [class.border-red-500]="hasError || isTouched()"
    [style.border-color]="(hasError || isTouched()) ? '#e3342f' : ''"
    (click)="toggleDropdown()"
  >
    <span
      *ngIf="label"
      class="text-xs font-semibold flex-shrink-0"
      [style.width]="labelWidth"
    >
      {{ label }}
    </span>

    <div class="flex justify-between items-center h-30-px cursor-pointer w-full">
      <span
        class="barlow text-xs font-lg pr-3 pl-3 italic truncate"
        [class.placeholder-color]="!selectedText"
        [class.touched-color]="onTouchTextErrorColor && isTouched() && !selectedText"
        [innerHTML]="selectedText || placeholder"
      >
      </span>
      <span [ngClass]="arrowClass()" class="material-icons flex-shrink-0">
        {{ arrowIcon() }}
      </span>
    </div>
  </div>

  <!-- Error message -->
  <span
    *ngIf="showError && !isOpen() && (errorMessage || isTouched())"
    class="font-semibold mt-1"
    style="color: #e3342f; font-size: 10px;"
  >
    {{ errorMessage || 'This field is required.' }}
  </span>

</div>

<!-- Panel — teleported to body via CDK -->
<ng-template #dropdownPanel>
  <div class="dropdown-panel" [class.select-active]="isOpen()" [class.opens-up]="openedUp()" role="listbox">
    <div
      *ngFor="let option of options"
      class="dropdown-item tracking-wide italic text-xs"
      [class.active]="option.label === selectedText"
      (click)="onSelect(option)"
      role="option"
      [attr.aria-selected]="option.label === selectedText"
      [innerHTML]="option.label"
    >
    </div>
  </div>
</ng-template>